import React from 'react';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import UserCourseDetail from '../User/Courses/CourseDetail';

const PublicCourseDetail = () => {
  return (
    <div className="min-h-screen flex flex-col bg-gray-50">
      <Header />
      <main className="flex-1 max-w-7xl 4xl:max-w-10xl mx-auto w-full px-4 sm:px-6 lg:px-8 py-8">
        <UserCourseDetail />
      </main>
      <Footer />
    </div>
  );
};

export default PublicCourseDetail;
